export default "__VITE_ASSET__CycZTnqq__"